import React, { useState } from 'react';
import './style.scss';
import { useMount } from '@mail/m-hooks';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Button from '../../../components/Button';
import SelectInput, { ISelectInputValueObj } from '../../../components/SelectInputGroup';
import Input from '../../../components/Input';
import TaskCard from '../../../components/TaskCard';
import { IOption } from '../../../components/Select';
import SMSTipsBox from '../../../components/SMSTipsBox';
import { VerifyCodeInput } from '../../common/VerifyCodeInput';

import GlobalAction from '../../../store/actions/global';
import GlobalModalBoxAction from '../../common/GlobalModalBox/action';

import { getAreaCode, getRepairAccount } from '../../../apis/Global';
import { getInquireTaskPublicity, IInquireTask } from '../../../apis/TaskPublicity';
import { ChinaPhoneReg, ForeignPhoneReg, mailReg } from '../../../common/RegExp';

import { getAccountExplainCheck } from '../../../apis/TaskPublicity';
import { getSMSVerifyCode } from '../../../apis/DataReview';
import { BoxType } from '../../../module/common/PhoneInput';


export type InquireType = 'account' | 'phone';

interface ITaskItem {
    uid: string,
    applicant: string,
    publicCountdown: number,
    taskId: number
}


export const InquireModalContent: React.FC = () => {
    const [inquireType, setInquireType] = useState<InquireType>('account');
    const [account, setAccount] = useState<string>('')
    const [accountError, setAccountError] = useState<string>('');
    const [taskCardError, setTaskCardError] = useState<string>('');
    const [phoneType, setPhoneType] = useState<IOption | null>({ id: "+86", name: "中国"});
    const [phone, setPhone] = useState<string>('');
    const [phoneError, setPhoneError] = useState<string>('');
    const [taskList, setTaskList] = useState<ITaskItem[]>([]);

    const [inquireLoading, setInquireLoading] = useState<boolean>(false);
    const [explainLoading, setExplainLoading] = useState<boolean>(false);

    const [showBox, setShowBox] = useState<boolean>(false);
    const [boxType, setBoxTyps] = useState<BoxType>('SMSBox');

    const [verifyCode, setVerifyCode] = useState<string>('');
    const [verifyCodeError, setVerifyCodeError] = useState<string>('');
    const [disableSMSBtn, setDisableSMSBtn] = useState<boolean>(false);

    const { phoneAreaOptions } = useSelector((state: any) => state.global);

    const dispatch = useDispatch();
    const history = useHistory();

    useMount(async () => {
        if (!phoneAreaOptions || !phoneAreaOptions.length) {
            const res = await getAreaCode();
            if (res && res.code === 200) {
                dispatch({
                    type: GlobalAction.UPDATE_PHONE_AREA_OPTIONS,
                    playload: res.result
                })
            }
        }
    })

    const toggleInquireType = (type: InquireType) => {
        if (inquireType !== type) {
            setInquireType(type);
            setShowBox(false);
            setBoxTyps('SMSBox');
            setAccountError('');
            setPhoneError('')
        }
        try {
            (window as any).mailStats.click(`choose_${type}_inquire_type`)
        } catch(e) {}
    }
    const handleAccountCheck = (value: string) => {
        if (!value) {
            setAccountError("请输入邮箱账号");
            return false;
        } else if (!mailReg.test(value)) {
            setAccountError('您的邮箱账号格式有误，请检查')
            return false;
        } else {
            setAccountError('');
            return true;
        }
    }
    const handleAccountChange = (value: string) => {
        setAccountError('');
        setAccount(value);
    }
    const handlePhoneChange = ({selValue, iptValue}: ISelectInputValueObj) => {
        setPhone(iptValue);
        setPhoneType(selValue);
        setPhoneError('');
        if (selValue?.id === '+86') {
            setBoxTyps('SMSBox');
        } else {
            setBoxTyps('VerifyBox');
        }
    }

    const handlePhoneCheck = ({selValue, iptValue}: ISelectInputValueObj) => {
        const type = selValue?.id;
        if (type === '+86' && iptValue && !ChinaPhoneReg.test(iptValue)) {
            setPhoneError('请输入正确的手机号码');
            return false;
        } else if (iptValue && !ForeignPhoneReg.test(iptValue)) {
            setPhoneError('请输入正确的手机号码');
            return false;
        } else if (iptValue) {
            setShowBox(true);
        }
        return true;
    }
    const handlePhoneInputCheck = ({selValue, iptValue}: ISelectInputValueObj) => {
        if (!iptValue) {
            setPhoneError('请输入完整的安全手机号码');
            return false;
        } 
        return true;
    }

    const changeInquireModalTitle = (type: InquireType) => {
        if (type === 'account') {
            dispatch({
                type: GlobalModalBoxAction.UPDATE_GLOBAL_MODAL_ONLY,
                playload: {
                    title: '该邮箱的公示信息如下'
                }
            })
        } else {
            dispatch({
                type: GlobalModalBoxAction.UPDATE_GLOBAL_MODAL_ONLY,
                playload: {
                    title: '该安全手机的邮箱公示信息如下'
                }
            })
        }
    }

    const handleInquire = async () => {
        try {
            (window as any).mailStats.click('task_modal_inquire_btn', { type: inquireType })
        } catch(e) {}
        let params: IInquireTask = {};
        if (inquireType === 'account') {
            if (!handleAccountCheck(account)) {
                return;
            }
            params.uid = account;
        } else {
            if (!handlePhoneInputCheck({selValue: phoneType, iptValue: phone}) || !handlePhoneCheck({selValue: phoneType, iptValue: phone})) {
                return;
            }
            if (phoneType?.id === '+86') {
                params.safePhone = phone;
            } else {
                if (!verifyCode) {
                    setVerifyCodeError('请输入验证码');
                    return;
                }
                params.safePhone = `${phoneType?.id}-${phone}`;
                params.code = verifyCode;
            }
             
        }
        setInquireLoading(true);
        //@ts-ignore
        const {code, result, desc} = await getInquireTaskPublicity(params);
        if (code === 200) {
            if (result && result.length) {
                setTaskList(result);
            }
            changeInquireModalTitle(inquireType)
        } else {
            if (inquireType === 'account') {
                setAccountError(desc || '网络繁忙，请稍后重试～');
            } else if (inquireType === 'phone') {
                setPhoneError(desc || '网络繁忙，请稍后重试～')
            }
        }
        setInquireLoading(false);
    }
    const handleExplain = async () => {
        try {
            (window as any).mailStats.click('task_modal_explain_btn', { type: inquireType });
        } catch(e) {}
        // 触发申诉
        if (taskList.length > 1) {
            return;
        }
        setExplainLoading(true);
        const res: any = await getAccountExplainCheck(taskList[0].taskId, taskList[0].uid);
        if (res.code === 200) {
            const accountRes = await getRepairAccount();
            if (accountRes && accountRes.code === 200) {
                dispatch({
                    type: GlobalAction.UPDATE_REPAIR_ACCOUNT,
                    playload: accountRes?.result?.uid
                })
                dispatch({
                    type: GlobalAction.UPDATE_IF_PAY_USER,
                    playload: accountRes?.result?.payUser
                })
            }
            history.push({
                pathname: '/',
                search: '?explaining=1'
            })
        } else {
            setAccountError(res.desc || '网络繁忙，请稍后重试～');
        }
        setExplainLoading(false);
        dispatch({
            type: GlobalModalBoxAction.UPDATE_GLOBAL_MODAL,
            playload: {
                show: false
            }
        })
    }
    const handleTaskCardClick = async (uid: string, taskId: number) => {
        const res: any = await getAccountExplainCheck(taskId, uid);
        if (res.code === 200) {
            const accountRes = await getRepairAccount();
            if (accountRes && accountRes.code === 200) {
                dispatch({
                    type: GlobalAction.UPDATE_REPAIR_ACCOUNT,
                    playload: accountRes?.result?.uid
                })
                dispatch({
                    type: GlobalAction.UPDATE_IF_PAY_USER,
                    playload: accountRes?.result?.payUser
                })
            }
            history.push({
                pathname: '/',
                search: '?explaining=1'
            })
            dispatch({
                type: GlobalModalBoxAction.UPDATE_GLOBAL_MODAL,
                playload: {
                    show: false,
                }
            })
        } else {
            setTaskCardError(res.desc || '网络繁忙，请稍后重试～')
        }
    }

    const handleOnVerityInputChange = (code: string) => {
        setVerifyCode(code);
        if (verifyCodeError) {
            setVerifyCodeError('');
        }
        if (disableSMSBtn) {
            setDisableSMSBtn(false);
        }
    }

    const handleVerifyInputBurCheck = () => {
        if (!verifyCode) {
            setVerifyCodeError('请输入验证码')
        }
    }

    const handleVerifyInputClick = async (curPhone: string) => {
        const res = await getSMSVerifyCode({
            phone: curPhone,
        });
        if (res && res.code === 314) {
            setDisableSMSBtn(true)
        }
    }
    return (
        <div className="task-publicity-inquire-modal" style={{textAlign: taskList.length > 1 ? 'left' : 'center'}}>
            {taskList && taskList.length ? <p className="task-publicity-inquire-modal-subtitle">如非您本人所提交的身份验证信息，请立即提起申诉</p> : null }
            {/* 层级问题，按钮放前面 */}
            {taskList && taskList.length <= 1 ?
                <div className="task-publicity-modal-action-bar">
                    {taskList.length === 1 ?
                        <Button loading={explainLoading} extraClass="task-publicity-modal-btn" color="primary" text="立即申诉" onClick={() => handleExplain()} /> :
                        <Button loading={inquireLoading} extraClass="task-publicity-modal-btn" color="primary" text="立即查询" onClick={() => handleInquire()} />
                    }
                </div> :
                null
            }
            {taskList && taskList.length > 0 ?
                <div className={`task-publicity-modal-result ${taskList && taskList.length > 6 ? 'task-publicity-modal-result-auto' : ''}`}>
                    {taskList.map((task: any) => {
                        return (
                            <TaskCard 
                                extraClass="small" 
                                key={task.taskId} 
                                taskId={task.taskId} 
                                uid={task.uid} 
                                applicant={task.applicant} 
                                publicCountdown={task.publicCountdown}
                                onClick={({uid, taskId}) => handleTaskCardClick(uid, taskId)}
                                showExplainBtn={taskList.length > 1}
                            />
                        )
                        
                    })}
                </div> :
                <>
                    <div className="task-publicity-select-btn">
                        <div onClick={() => toggleInquireType('account')} className={`task-publicity-select-left ${inquireType === 'account' ? 'actived' : ''}`}>邮箱账号</div>
                        <div onClick={() => toggleInquireType('phone')} className={`task-publicity-select-right ${inquireType === 'phone' ? 'actived' : ''}`}>安全手机</div>
                    </div>
                    <div className="task-publicity-main">
                        {inquireType === 'account' ?
                            <Input
                                extraClass="task-publicity-input"
                                onChange={(value) => handleAccountChange(value)}
                                onBur={(value) => handleAccountCheck(value)}
                                placeholder="请输入完整的邮箱账号后，再继续申诉"
                                errorText={accountError}
                                maxLength={30}
                            /> :
                            <>
                                <SelectInput
                                    extraClass="task-publicity-select-input"
                                    placeholder="请输入完整的安全手机号码"
                                    optionType="phone"
                                    defaultSelValue={{ id: "+86", name: "中国" }}
                                    options={phoneAreaOptions || []}
                                    onChange={(value) => handlePhoneChange(value)}
                                    onInputBur={handlePhoneInputCheck}
                                    onBur={handlePhoneCheck}
                                    showId={true}
                                    maxLength={30}
                                    errorText={phoneError}
                                />
                            </>
                        }
                    </div>
                    {inquireType === 'phone' && showBox && boxType === 'SMSBox' ?
                        <div className="task-publicity-modal-sms-box">
                            <SMSTipsBox />
                        </div> :
                        null
                    }
                    {inquireType === 'phone' && showBox && boxType === 'VerifyBox' ?
                        <div className="task-publicity-modal-verify-input">
                            <VerifyCodeInput
                                verifyCode={verifyCode}
                                useLabel={false}
                                phoneType={phoneType as IOption}
                                phoneNumber={phone}
                                errorText={verifyCodeError}
                                handleOnChange={handleOnVerityInputChange}
                                handleCheckOnBur={handleVerifyInputBurCheck}
                                handleClick={handleVerifyInputClick}
                                disableBtn={disableSMSBtn}
                            />
                        </div>  :
                        null
                    }
                </>
            }
             {taskList && taskList.length > 0 && taskCardError ? <p className="task-publicity-modal-result-error">{taskCardError}</p> : null} 
        </div>
    )
}

interface IExplain {
    chosenAccount: string,
    choseTaskId: number
}

export const ExplainConfirmModalContent: React.FC<IExplain> = ({ chosenAccount, choseTaskId }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [explainAccount, setExplainAccount] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [explainAccountError, setExplainAccountError] = useState<string>('');
    const handleExplainAccoundChange = (value: string) => {
        if (!AccountCheck) {
            return;
        }
        setExplainAccountError('');
        setExplainAccount(value);
    }
    const AccountCheck = (value: string) => {
        if (!value) {
            setExplainAccountError("请输入邮箱账号");
            return false;
        } else if (!mailReg.test(value)) {
            setExplainAccountError('您的邮箱账号格式有误，请检查')
            return false;
        } else {
            setExplainAccountError('');
            return true;
        }
    }
    const handleExplainBtnClick = async () => {
        try {
            (window as any).mailStats.click('modal_continue_explain_btn')
        } catch(e) {}
        if(loading || !AccountCheck(explainAccount)) {
            return;
        }
        setLoading(true);
        const res:any = await getAccountExplainCheck(choseTaskId, explainAccount);
        setLoading(false);
        if (res.code === 200) {
            const accountRes = await getRepairAccount();
            if (accountRes && accountRes.code === 200) {
                dispatch({
                    type: GlobalAction.UPDATE_REPAIR_ACCOUNT,
                    playload: accountRes?.result?.uid
                })
                dispatch({
                    type: GlobalAction.UPDATE_IF_PAY_USER,
                    playload: accountRes?.result?.payUser
                })
            }
            history.push({
                pathname: '/',
                search: `?explaining=1`
            })
            dispatch({
                type: GlobalModalBoxAction.UPDATE_GLOBAL_MODAL,
                playload: {
                    show: false
                }
            })
        } else {
            setExplainAccountError(res.desc);
        }
    }
    return (
        <div className="task-publicity-explain-confirm-modal-content">
            <p className="task-publicity-explain-confirm-content">
                如您对该账号的归属提出了异议，请根据后续页面指引提供邮箱使用信息和身份验证资料。系统将根据争议双方的资料匹配得分来判断归属，在此之前，请先完整输入要申诉的账号：
            </p>
            <Input
                extraClass="task-publicity-explain-confirm-modal-input"
                onChange={value => handleExplainAccoundChange(value)} 
                onBur={value => AccountCheck(value)} 
                placeholder="请输入完整的邮箱账号后，再继续申诉"
                errorText={explainAccountError}
                maxLength={30}
            />
            <div className="task-publicity-explain-modal-action-bar">
                <Button extraClass="task-publicity-modal-btn" text="取消申诉" onClick={() => {
                    dispatch({
                        type: GlobalModalBoxAction.UPDATE_GLOBAL_MODAL,
                        playload: {
                            show: false
                        }
                    })
                }} />
                <Button loading={loading} extraClass="task-publicity-modal-btn" color="primary" text="继续申诉" onClick={() => handleExplainBtnClick()} />
            </div>
        </div>
    )
}
